import { forwardRef } from "react";

/**
 * LinkDialog - floating panel for inserting/editing a hyperlink.
 *
 * Props:
 *  pos        – { top, left } position of the panel; null hides it
 *  value      – current URL string
 *  onChange   – (url: string) => void
 *  onApply    – (url: string) => void  — called on Enter or "Apply"
 *  onRemove   – () => void             — called on Escape or "Remove"
 *  isActive   – boolean; shows "Remove" button when the cursor is on a link
 */
export const LinkDialog = forwardRef(({ pos, value, onChange, onApply, onRemove, isActive }, ref) => {
  if (!pos) return null;

  return (
    <div ref={ref} className="rte-link-dialog" style={{ top: pos.top, left: pos.left }}>
      <input
        type="url"
        className="rte-link-input"
        placeholder="https://..."
        value={value}
        onChange={(e) => onChange(e.target.value)}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            e.preventDefault();
            onApply(value);
          } else if (e.key === "Escape") {
            e.preventDefault();
            onRemove();
          }
        }}
        // eslint-disable-next-line jsx-a11y/no-autofocus -- intentional for UX
        autoFocus
      />
      <div className="rte-link-actions">
        <button
          type="button"
          className="rte-btn"
          onMouseDown={(e) => {
            e.preventDefault();
            onApply(value);
          }}
        >
          Apply
        </button>
        {isActive && (
          <button
            type="button"
            className="rte-btn"
            title="Remove link"
            onMouseDown={(e) => {
              e.preventDefault();
              onRemove();
            }}
          >
            <span className="material-icons">link_off</span>
          </button>
        )}
      </div>
    </div>
  );
});

LinkDialog.displayName = "LinkDialog";
